import writeXlsxFile, { Cell, Row, SheetData } from 'write-excel-file/browser';
import { SearchResult } from 'src/app/services/api-service.service';

const HEADER_TEXT_COLOR = '#FFFFFF';
const HEADER_BACKGROUND_COLOR = '#00629D';

const COLUMNS = [
    { width: 15 },
    { width: 15 },
    { width: 25 },
    { width: 25 },
    { width: 25 }
];

const COLUMN_HEADINGS = ['Claim Number', 'Medicare ID', 'Last Name', 'First Name', 'Date of Entitlement'];

export function searchExportExcelFile(data?: SearchResult): Promise<Blob> {
    // ExcelJS only styled the header and set column widths when data was present.
    const styled = data != undefined;

    function headerRow(): Row {
        return COLUMN_HEADINGS.map((heading): Cell => styled
            ? {
                value: heading,
                fontWeight: 'bold',
                textColor: HEADER_TEXT_COLOR,
                backgroundColor: HEADER_BACKGROUND_COLOR
            }
            : { value: heading });
    }

    const rows: SheetData = [headerRow()];

    if(data != undefined){
        if(data.PaidActData != undefined && data.PaidActData.length > 0)
        {
            data.PaidActData.forEach(function(item){
                rows.push([
                    { value: item.ClaimNo },
                    { value: item.MedicareId },
                    { value: item.LastName },
                    { value: item.FirstName },
                    { value: item.DateOfEntitlement }
                ]);
            });
        }
    }

    return writeXlsxFile(rows, {
        sheet: 'Search Results',
        columns: styled ? COLUMNS : undefined
    }).toBlob();
}